import React from 'react'

/**
 * 页面授权的共享内容容器。
 * 独立授权页和 Profile 里的嵌入面板都通过这里承载当前页面、状态提示和授权记录，
 * 避免两套布局随着需求变更逐渐不一致。
 */
const VibeOwnerAccessPermissionPanel = ({
    setupState,
    setupNotice,
    currentPage,
    currentPageView,
    applicationEntryUrl,
    onOpenApplication,
    onCreatePermission,
    onRenderRouteSync,
    children,
}) => (
    <div className="vibe-owner-access-permission-panel vibe-owner-access-list">
        {setupState === 'GRANT_ACCESS' && setupNotice}
        {currentPage && currentPageView}
        <div className="vibe-owner-access-list-panel">
            <div className="vibe-owner-access-list-heading">
                <div><h5 className="ant-typography">授权记录</h5></div>
                <div className="ant-space">
                    <button type="button" className="ant-btn" disabled={!applicationEntryUrl} onClick={onOpenApplication}>打开应用</button>
                    {setupState === 'COMPLETE' && <button type="button" className="ant-btn ant-btn-primary" onClick={onCreatePermission}>分配权限</button>}
                </div>
            </div>
            {children}
        </div>
        {onRenderRouteSync?.()}
    </div>
)

export default VibeOwnerAccessPermissionPanel
